import React, { memo, useState } from "react";
import { Form } from "react-bootstrap";
import ArrowIconDisabled from "../../../../../../assets/img/arrow-filter-solid-disabled.svg";
import ArrowIcon from "../../../../../../assets/img/arrow-filter-solid.svg";
import FilterIcon from "../../../../../../assets/icons/Icon - FilterDisabled.svg";
import FilterIconOn from "../../../../../../assets/icons/Icon - Filter.svg";
import FiltersPanel from "../../../../../../components/filter-panel/filter-panel";
import {
  selectTemplateTasks,
  selectSelectedTemplateTasks,
} from "../../../../../../redux/templates-tasks/template-task-selector";
import { setSelectedTemplateTasks } from "../../../../../../redux/templates-tasks/template-task-actions";
import "./template-task-header.styles.scss";
import { selectUser } from "../../../../../../redux/user/user-selector";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";

const tableHeaderInfo = [
  {
    name: "TASK NAME",
    filterName: "Tasks",
    containerClassName: "th-template-task-name-col",
    hasFilter: true,
    hasSort: true,
    filterType: "ProjectTemplateTaskNameNew",
    sortBy: "Name",
  },
  {
    name: "DESCRIPTION",
    filterName: "",
    containerClassName: "th-template-task-description-col",
    hasFilter: false,
    hasSort: true,
    filterType: "",
    sortBy: "Description",
  },
  {
    name: "PRIORITY",
    filterName: "",
    containerClassName: "th-template-task-priority-col",
    hasFilter: false,
    hasSort: true,
    filterType: "",
    sortBy: "Priority",
  },
  {
    name: "TASK TYPE",
    filterName: "",
    containerClassName: "th-template-task-type-col",
    hasFilter: true,
    hasSort: false,
    filterType: "ProjectTemplateTaskTypeNew",
    sortBy: "type",
  },
  // Part of phasing out subtasks
  // {
  //   name: "SUBTASKS",
  //   filterName: "",
  //   containerClassName: "th-template-task-subtasks-col",
  //   hasFilter: false,
  //   hasSort: true,
  //   filterType: "",
  //   sortBy: "SubTasks",
  // },
  {
    name: "ATTACHMENT",
    filterName: "",
    containerClassName: "th-template-task-attachment-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
  {
    name: "ACTIONS",
    filterName: "",
    containerClassName: "th-template-task-actions-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
];

const TemplateTasksHeaderNew = ({
  changeData,
  refreshPage,
  tasks,
  taskTypes,
}) => {
  const [activeFilterType, setActiveFilterType] = useState("");
  const [activeSortType, setActiveSortType] = useState("");
  const [isDescendingSort, setIsDescendingSort] = useState(false);
  const [selectedFilterRows, setSelectedFilterRows] = useState([]);

  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const data = useSelector(selectTemplateTasks);
  const selectedRows = useSelector(selectSelectedTemplateTasks);

  const onSelectAll = (e) => {
    let tempList = [];
    if (e.target.checked) {
      data.forEach((task) => {
        tempList.push(task.Id);
      });
    }
    dispatch(setSelectedTemplateTasks(tempList));
  };

  const passPayload = (label) => {
    switch (label) {
      case "TASK NAME":
        return tasks;
      case "TASK TYPE":
        return taskTypes;
      default:
        return [];
    }
  };

  const updateFilter = (selectedRows, type) => {
    setSelectedFilterRows(selectedRows);
    setActiveFilterType(type);
  };

  const clearFilter = () => {
    setActiveFilterType("");
    setSelectedFilterRows([]);
    refreshPage();
  };

  const saveFilter = (newFilter) => {
    //Buffer function makes sure we only makes the necessary changes and nothing else
    changeData(newFilter);
  };

  const handleSortClick = (sortType) => {
    //All the sortDesc logic is stored in the search query in UsersTableContainer
    if (activeSortType === sortType && !isDescendingSort) {
      //If sorting by ascending, then turn off on this click
      setActiveSortType("");
      setIsDescendingSort(false);
      changeData(undefined, "Name", false);
      return;
    }

    if (activeSortType !== sortType) {
      // If not sorting yet, just set to sorting
      setActiveSortType(sortType);
      setIsDescendingSort(true);
      changeData(undefined, sortType, true);
      return;
    }

    //Now sorting upwards
    setIsDescendingSort(false);
    changeData(undefined, sortType, false);
  };

  return (
    <thead className="template-task-table-headers">
      <tr>
        <th className="th-template-task-checkbox-col">
          <Form.Check
            type={"checkbox"}
            disabled={!user?.privileges.Templates.Delete}
            onClick={(e) => onSelectAll(e)}
            checked={selectedRows.length === data.length}
          />
        </th>
        {tableHeaderInfo.map((labelInfo) => {
          return (
            <th className={labelInfo.containerClassName} key={labelInfo.name}>
              <div className="th-container">
                <div className={`th-icon-filter`}>
                  {labelInfo.hasFilter && (
                    <FiltersPanel
                      selected={
                        activeFilterType === labelInfo.filterType
                          ? selectedFilterRows
                          : []
                      }
                      filterIcon={
                        activeFilterType === labelInfo.filterType
                          ? FilterIconOn
                          : FilterIcon
                      }
                      header={labelInfo.filterName}
                      type={labelInfo.filterType}
                      updateSelected={updateFilter}
                      save={saveFilter}
                      clear={clearFilter}
                      change={() => {}}
                      close={() => {}}
                      adminPayload={passPayload(labelInfo.name)}
                    ></FiltersPanel>
                  )}
                </div>
                <div className="th-name">{labelInfo.name}</div>
                {labelInfo.hasSort && (
                  <div className="arrow-holder">
                    <img
                      className="th-icon-up"
                      src={
                        activeSortType === labelInfo.sortBy && !isDescendingSort
                          ? ArrowIcon
                          : ArrowIconDisabled
                      }
                      alt="filter-arrow"
                      onClick={() => handleSortClick(labelInfo.sortBy)}
                    />
                    <img
                      className="th-icon-down"
                      src={
                        activeSortType === labelInfo.sortBy && isDescendingSort
                          ? ArrowIcon
                          : ArrowIconDisabled
                      }
                      alt="filter-arrow"
                      onClick={() => handleSortClick(labelInfo.sortBy)}
                    />
                  </div>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

TemplateTasksHeaderNew.propTypes = {
  changeData: PropTypes.func,
  refreshPage: PropTypes.func,
  tasks: PropTypes.array,
  taskTypes: PropTypes.array,
};

export default memo(TemplateTasksHeaderNew);
